module.exports = __webpack_public_path__ + "static/img/newmedia1.48471f75.png";